import apiClient from './axiosClient';

export const invoiceApi = {
  getInvoices: (params) =>
    apiClient.get('/invoices', { params }),
  // params: { billingProviderId, status, page, pageSize }

  getInvoiceDetail: (id) =>
    apiClient.get(`/invoices/${id}`),

  payInvoice: (id, paymentData) =>
    apiClient.post(`/invoices/${id}/pay`, paymentData),
};
